import { indexPagesData } from 'utils/index-pages-data';
import { HintsTabComponent } from './components/hints-tab/hints-tab.component';
import { LogsComponent } from 'shared/logs/logs.component';
import { CommentsComponent } from 'shared/comments/comments.component';


export const rightPanelNavs: any[] = [
  {
    title: 'Hints',
    name: 'hints',
    active: false,
    component: HintsTabComponent,
  },
  {
    title: 'Logs',
    name: 'logs',
    active: false,
    component: LogsComponent,
    availableFor: [...indexPagesData.working.itemStatuses],
  },
  {
    title: 'Comments',
    name: 'comments',
    active: false,
    component: CommentsComponent,
    availableFor: [
      ...indexPagesData.working.itemStatuses,
      ...indexPagesData.published.itemStatuses,
    ],
  }
];
